/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Button, Tooltip } from "reactstrap";
import { UniqKey } from "../util/Key";
import useUpdateState from "../util/useUpdateState";

export const actionButtonTypes = {
  confirm: { icon: "check-lg", color: "success" },
  cancel: { icon: "x-lg", color: "danger" },
  close: { icon: "x-lg", color: "secondary" },
  disconnect: { icon: "wifi-off", color: "secondary" },
  send: { icon: "send", color: "secondary" },
  view: { icon: "search", color: "secondary" },
  show: { icon: "eye", color: "secondary" },
  hide: { icon: "eye-slash", color: "secondary" },
  add: { icon: "plus-circle", color: "success" },
  layout: { icon: "layout-wtf", color: "info" },
  smart: { icon: "robot", color: "ai" },
  copy: { icon: "files", color: "secondary" },
  edit: { icon: "pencil", color: "success" },
  delete: { icon: "trash3", color: "danger" },
  print: { icon: "printer", color: "secondary"},
  download: { icon: "cloud-download", color: "secondary"},
  upload: { icon: "cloud-upload", color: "secondary" },
  reset: { icon: "arrow-clockwise", color: "info"},
  preview: { icon: "box-arrow-up-right", color: "secondary"}
};

const ActionButton = ({
  className,
  type,
  tooltip,
  tooltipPlacement,
  size = "sm",
  outline = true,
  disabled = false,
  onClick,
  onMouseOver,
  onMouseOut,
}) => {
  // tooltip state
  const [state, , updateState] = useUpdateState({
    id: `action-button-${UniqKey()}`,
    open: false
  });

  // get type variables
  const { icon, color } = actionButtonTypes[type] ?? { icon: "square" };

  // styles
  let buttonStyle;
  switch (size) {
    case "sm": buttonStyle = { height: "28px" }; break;
    case "md": buttonStyle = { height: "38px" }; break;
    case "lg": buttonStyle = { height: "48px" }; break;
    default:
      size = "sm";
      buttonStyle = { height: "28px" };
      break;
  }

  return (
    <>
      <Button
        id={state.id}
        className={className}
        color={disabled ? "secondary" : color}
        outline={outline}
        size={size}
        disabled={disabled}
        style={buttonStyle}
        onClick={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        <i className={`icon bi bi-${icon}`} />
      </Button>
      {tooltip && (
        <Tooltip
          placement={tooltipPlacement}
          isOpen={state.open}
          target={state.id}
          toggle={() => updateState({ open: !state.open })}
        >
          {tooltip}
        </Tooltip>
      )}
    </>
  );
};

export default ActionButton;
